import { render, staticRenderFns } from "./ScorekeeperLiveLayout.vue?vue&type=template&id=2e5bc9ec"
import script from "./ScorekeeperLiveLayout.vue?vue&type=script&lang=js"
export * from "./ScorekeeperLiveLayout.vue?vue&type=script&lang=js"
import style0 from "./ScorekeeperLiveLayout.vue?vue&type=style&index=0&id=2e5bc9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports